import { Account } from './account.model';
import { Group } from './group.model';

export const ACTION_QUEUE_STATUS_CANCELLED = 'cancelled';
export const ACTION_QUEUE_STATUS_COMPLETED = 'completed';
export const ACTION_QUEUE_STATUS_DISMISSED = 'dismissed';
export const ACTION_QUEUE_STATUS_ERROR = 'error';
export const ACTION_QUEUE_STATUS_IN_PROGRESS = 'in-progress';
export const ACTION_QUEUE_STATUS_INITIALIZING = 'initializing';
export const ACTION_QUEUE_STATUS_PENDING = 'pending';
export const ACTION_QUEUE_STATUS_SEMI_COMPLETED = 'semi-completed';
export const ACTION_QUEUE_DEACTIVATE = 'deactivate';
export const ACTION_QUEUE_DELETE = 'delete';
export const ACTION_QUEUE_UPDATE = 'update';
export const ACTION_QUEUE_INVITE = 'invite';
export const ACTION_QUEUE_TYPES = {
  ACTION_QUEUE_DEACTIVATE,
  ACTION_QUEUE_DELETE,
  ACTION_QUEUE_INVITE,
  ACTION_QUEUE_UPDATE,
};
export const ACTION_QUEUE_STATUSES = {
  ACTION_QUEUE_STATUS_CANCELLED,
  ACTION_QUEUE_STATUS_COMPLETED,
  ACTION_QUEUE_STATUS_DISMISSED,
  ACTION_QUEUE_STATUS_ERROR,
  ACTION_QUEUE_STATUS_INITIALIZING,
  ACTION_QUEUE_STATUS_IN_PROGRESS,
  ACTION_QUEUE_STATUS_PENDING,
  ACTION_QUEUE_STATUS_SEMI_COMPLETED,
};
export const IMPORT_HISTORY_STATUS_INCOMPLETE = 'incomplete';

export interface ErrorCause {
  created_at?: Date;
  message?: string;
}

type ActionQueueType =
  | typeof ACTION_QUEUE_TYPES.ACTION_QUEUE_DELETE
  | typeof ACTION_QUEUE_TYPES.ACTION_QUEUE_INVITE
  | typeof ACTION_QUEUE_TYPES.ACTION_QUEUE_UPDATE;

type ActionQueueStatusType =
  | typeof ACTION_QUEUE_STATUSES.ACTION_QUEUE_STATUS_CANCELLED
  | typeof ACTION_QUEUE_STATUSES.ACTION_QUEUE_STATUS_COMPLETED
  | typeof ACTION_QUEUE_STATUSES.ACTION_QUEUE_STATUS_DISMISSED
  | typeof ACTION_QUEUE_STATUSES.ACTION_QUEUE_STATUS_ERROR
  | typeof ACTION_QUEUE_STATUSES.ACTION_QUEUE_STATUS_IN_PROGRESS
  | typeof ACTION_QUEUE_STATUSES.ACTION_QUEUE_STATUS_INITIALIZING
  | typeof ACTION_QUEUE_STATUSES.ACTION_QUEUE_STATUS_PENDING
  | typeof ACTION_QUEUE_STATUSES.ACTION_QUEUE_STATUS_SEMI_COMPLETED;

export interface ActionQueue {
  _id: string;
  action: ActionQueueType;
  created_at: Date;
  error_causes: ErrorCause[];
  flat_file_generation: number;
  flat_file_name: string;
  group: Group['_id'];
  status: ActionQueueStatusType;
  updated_at?: Date;
}

export interface ImportHistory {
  account: { full_name: Account['full_name'] };
  action_queues: ActionQueue[];
  file_url: string;
  flat_file_generation: ActionQueue['flat_file_generation'];
  flat_file_name: ActionQueue['flat_file_name'];
  group: Pick<Group, '_id' | 'name' | 'slug'>;
}
